import i18next from 'i18next';

i18next.addResources('es', 'EjeParticipantsTable', {
  relationship: 'Vínculo',
  name: 'Nombre',
  representatives: 'Representante',
  address: 'Domicilio',
  viewAddress: 'Ver domicilio',
  addressModalTitle: 'Domicilios',
  noAddress: 'Sin domicilio',
  searchPlaceholder: 'Buscar por nombre, vínculo o representante...',
  empty: 'No se encontraron participantes',
  loadMore: 'Cargar más',
  loading: 'Cargando...',
  showing: 'Mostrando {{count}} de {{total}} resultados'
});

i18next.addResources('es', 'EjeEntriesTable', {
  number: 'Número',
  title: 'Título',
  signatureDate: 'Fecha de firmado',
  signedBy: 'Firmantes',
  document: 'Documento',
  attachments: 'Adjuntos',
  viewDocument: 'Ver documento',
  viewAttachments: 'Ver adjuntos',
  attachmentsModalTitle: 'Adjuntos',
  unnamedFile: 'Archivo sin nombre',
  typeFilter: 'Tipos',
  typeCourtOrder: 'Despachos',
  typeMotion: 'Escritos',
  typeNotice: 'Cedulas',
  typeNote: 'Notas',
  typeSearchPlaceholder: 'Buscar tipo...',
  typeEmpty: 'No se encontraron tipos',
  searchPlaceholder: 'Buscar por título, número o firmantes...',
  empty: 'No se encontraron actuaciones'
});

i18next.addResources('es', 'EjeRelatedCasesTable', {
  cuij: 'CUIJ',
  title: 'Carátula',
  relationType: 'Tipo de relación',
  linkedDate: 'Fecha de vinculación',
  searchPlaceholder: 'Buscar por CUIJ, carátula, tipo de relación o fecha...',
  empty: 'No se encontraron causas relacionadas',
  loadMore: 'Cargar más',
  loading: 'Cargando...',
  showing: 'Mostrando {{count}} de {{total}} resultados'
});
